export function mergeToggleSearchResults<Result>(
  promoRequested: boolean,
  promoResults: Array<Result> | undefined,
  voucherRequested: boolean,
  voucherResults: Array<Result> | undefined,
) {
  const hasPromoResponse = promoRequested && promoResults !== undefined;
  const hasVoucherResponse = voucherRequested && voucherResults !== undefined;

  if (!hasPromoResponse && !hasVoucherResponse) {
    return undefined;
  }

  return [
    ...(hasPromoResponse ? promoResults.map((result) => ({ ...result, entity: 'promo' as const })) : []),
    ...(hasVoucherResponse ? voucherResults.map((result) => ({ ...result, entity: 'voucher' as const })) : []),
  ];
}
